import { render, staticRenderFns } from "./AboutAlliances.vue?vue&type=template&id=340de127&scoped=true&"
import script from "./AboutAlliances.vue?vue&type=script&lang=js&"
export * from "./AboutAlliances.vue?vue&type=script&lang=js&"
import style0 from "./AboutAlliances.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AboutAlliances.vue?vue&type=style&index=1&id=340de127&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340de127",
  null
  
)

export default component.exports